import CTA from 'components/CTA';
import FeaturesList from 'components/FeaturesList';
import HeadingAndDesc from 'components/HeadingAndDesc';
import Metadata from 'components/Metadata';
import TwoCols from 'components/TwoCols';
import Videos from 'components/Videos';
import PropTypes from 'prop-types';
import React from 'react';
import Banner from './Banner';
import Customers from './Customers';

const FeaturesTpl = ({ data }) => {
  const {
    featuresPage: {
      title,
      meta,
      featuresBanner,
      features,
      featureHeading,
      featuresList,
      freeTrial,
      videos
    },
    customersPage: { testimonial },
  } = data;
  return (
    <div>
      <Metadata title={title} description={meta.description} />
      <Banner data={featuresBanner} />
      <TwoCols data={features} padding="BottomXl" />
      <HeadingAndDesc data={featureHeading} theme="Blue" padding="TopXl" />
      <FeaturesList data={featuresList} theme="Blue" padding="BottomXl" />
      <Customers data={testimonial} />
      <Videos data={videos} />
      <CTA {...freeTrial} />
    </div>
  );
};

FeaturesTpl.propTypes = {
  data: PropTypes.object,
};

export default FeaturesTpl;
